import type {MembershipApiModel} from '../../../../api/membership';

import {membershipStore} from '../../../../api/membership';
import {DeleteInviteStrategy} from './DeleteInviteStrategy';

export class DeleteProposedMembershipStrategy extends DeleteInviteStrategy {
  constructor(private membership: MembershipApiModel) {
    super();
  }

  async deleteInvite() {
    await membershipStore.coach.delete(this.membership);
  }
}
